<template>
  <div role="dialog"
    id="assessment-modal"
    class="assessment-modal popup-modal"
    :class="{ 'is-active': isOpen }"
  >
    <!-- <div class="modal-background"></div> -->
    
    <div class="modal-card">
        <a role="button" tabindex="0" @click="onCancel" @keydown.enter="onCancel" id="closeButton" class="close-white float-right"></a><br>
      <header class="modal-head">
        <h4 class="assessment-modal-title">Do you want to save the changes</h4>
      </header>
      <section>
        <p>
          You have made some changes to the assessment. <br />
          If you don’t save them before leaving the assessment, you will lose
          them.
        </p>
      </section>
      <footer class="modal-foot d-flex flex-md-row flex-column-reverse">
          <a role="button" tabindex="0" class="cancel" @click="onCancel" @keydown.enter="onCancel">Cancel</a>
          <a role="button" tabindex="0" class="nosave" @click="onDontSave" @keydown.enter="onDontSave"
            >Don't save<span class="angle-right-white"></span
          ></a>
          <button class="cta-green-205" @click="onSave" @keydown.enter="onSave">
            Save changes<span class="angle-right-green"></span>
          </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    onDontSave() {
      this.$emit("handleDontSave");
    },
    onSave() {
      this.$emit("handleSave");
    },
    onCancel() {
      //this.isOpen = false;
      this.$emit("handleCancel");
    }
  }
};
</script>

<style lang="sass" scoped></style>
